/**
 * Searchspring banner alt-text safety net (ADA / WCAG).
 *
 * Searchspring merchandising banners are injected as raw HTML at runtime, so
 * their <img> alt text cannot be controlled from Liquid. This backfills alt on
 * any banner image that renders without it. Meaningful alt should still be set
 * in the Searchspring merchandising dashboard — this is only a guard.
 *
 * Runs on initial render and re-runs on every Searchspring re-render
 * (filter / sort / paginate) via a MutationObserver on [data-ss-container].
 */
(function () {
  var BANNER_IMG_SELECTOR = [
    '.searchspring-page__top-banner img',
    '.searchspring-page__bottom-banner img',
    '.searchspring-page__sidebar-banner img',
    '.product-card--banner img'
  ].join(',');

  var FALLBACK_ALT = 'Promotional banner';

  function backfillAlt(root) {
    var scope = root || document;
    var imgs = scope.querySelectorAll(BANNER_IMG_SELECTOR);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      // Only touch images with missing or empty alt.
      if (img.getAttribute('alt')) continue;
      var link = img.closest('a');
      var alt = (link && link.getAttribute('title')) || img.getAttribute('title') || FALLBACK_ALT;
      img.setAttribute('alt', alt.trim() || FALLBACK_ALT);
    }
  }

  function init() {
    var container = document.querySelector('[data-ss-container]');
    // Backfill whatever is already on the page.
    backfillAlt(container || document);

    if (!container || typeof MutationObserver === 'undefined') return;

    // Re-run once per render batch. We observe childList only and set an
    // attribute, so this never re-triggers itself.
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        backfillAlt(container);
      });
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
